import { render } from "./events.vue?vue&type=template&id=57cceaf4&scoped=true"
import script from "./events.vue?vue&type=script&lang=js"
export * from "./events.vue?vue&type=script&lang=js"

import "./events.vue?vue&type=style&index=0&id=57cceaf4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-57cceaf4"

export default script